import { getProfile, getProfileByName, updatePlayer } from '../../store/auth'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Row, Col, Form } from 'react-bootstrap';

import { Modal, Button } from 'react-bootstrap';
import { getPlayerPokemons, getPokemonsByPlayer } from '../../store/pokemon';
import PokemonProfile from '../Component/PokemonProfile';
import GoldSiverHeader from '../HomePage/GoldSiverHeader';
import { FaEdit } from "react-icons/fa";
import { getHonors, presentation } from '../../store/other';
import Silver from '../Component/Silver';
import Gold from '../Component/Gold';
import moment from 'moment';
import Online from '../Component/Online';
import Offline from '../Component/Offline';
import { getUserBadge } from '../../store/extras';
import { Tooltip } from 'react-tooltip';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoint';
import { useTranslation } from 'react-i18next';


function Profile() {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const params = useParams();
    const [disableFlag, setDisableFlag] = useState(true)
    let current_name = JSON.parse(localStorage.getItem('userData'))?.playerName
    let name = JSON.parse(localStorage.getItem('userData'))?.playerName
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [presentationData, setPresentation] = useState('')
    const user_badges = useSelector(state => state.extras.user_badges)
    const [userPokemon, setUserPokemon] = useState([])
    const [activeTab, setActiveTab] = useState('results') // 'results' or 'badges'

    if (queryParams.get('playername')) {
        name = queryParams.get('playername');
    }
    const player_pokemons = useSelector(state => state.pokemon.player_pokemons);

    const profile_by_name = useSelector(state => state.auth.profile_by_name)
    const honors = useSelector(state => state.other.honors)
    const [modal, setModal] = useState(false)

    const [region, setRegion] = useState(profile_by_name?.wereld)
    const handleCloseModal = () => setModal(false);
    const [hoveredId, setHoveredId] = useState(null);

    const handlesubmit = () => {
        dispatch(updatePlayer(region))
    }
    
    const handleStartPvP = async () => {
        // Check if user is logged in
        const userData = JSON.parse(localStorage.getItem('userData') || 'null');
        const token = localStorage.getItem('token') || localStorage.getItem('session_token');
        
        if (!userData || !token) {
            toast.error(t('You must be logged in to start a PVP battle'));
            navigate('/login');
            return;
        }
        
        if (!profile_by_name?.user_id) {
            toast.error(t('Cannot start PVP battle - player not found'));
            return;
        }
        
        try {
            // Create invitation instead of direct battle
            const response = await axios.post(API_ENDPOINTS.CREATE_PVP_INVITATION, {
                opponent_user_id: profile_by_name.user_id
            });
            
            if (response.data && response.data.success) {
                toast.success(t('PVP invitation sent! Waiting for opponent to accept...'));
            } else {
                toast.error(response.data?.error || t('Failed to send PVP invitation'));
            }
        } catch (error) {
            console.error('Error sending PVP invitation:', error);
            if (error.response?.status === 401) {
                toast.error(t('You must be logged in to start a PVP battle'));
                navigate('/login');
            } else {
                toast.error(error.response?.data?.error || t('Failed to send PVP invitation'));
            }
        }
    }

    useEffect(() => {
        setRegion(profile_by_name?.wereld)
        setPresentation(profile_by_name?.profiel)
    }, [profile_by_name])
    const handleMouseEnter = (id) => {
        setHoveredId(id);
        setTimeout(() => {
            const element = document.getElementById(`pokemon-popup-${id}`);
            if (element) {
                const { right, left, width } = element.getBoundingClientRect();
                const viewportWidth = window.innerWidth;

                // Check if the popup overflows from the right side
                if (right > viewportWidth) {
                    element.style.position = 'absolute';
                    element.style.right = '10px';
                    element.style.left = 'auto';
                    element.style.transform = 'translate(0%,0%) !important';
                    console.log('Adjusted Right:', element.style.right);
                }
                // Check if the popup overflows from the left side
                else if (left < 0) {
                    element.style.position = 'absolute';
                    element.style.left = '10px';
                    element.style.transform = 'translate(0%,0%) !important';

                    element.style.right = 'auto';
                    console.log('Adjusted Left:', element.style.left);
                }
                // Handle near-left-edge cases
                else if (left < 200) {
                    element.style.position = 'absolute';
                    element.style.left = `0px`;
                    element.style.right = 'auto';
                    element.style.transform = 'translate(0%,0%) !important';
                    console.log('Adjusted Near Left:', element.style.left);
                }
            } else {
                console.warn(`Element with ID pokemon-popup-${id} not found.`);
            }
        }, 0); // Allow for DOM updates to settle
    };

    const handleMouseLeave = () => {
        setHoveredId(null);
    };
    const init = async () => {
        let data = await dispatch(getProfileByName(name)).unwrap()
        if (!data) {
            navigate('/home')
        }
    }
    const handlePresentation = () => {
        setDisableFlag(true)
        dispatch(presentation(presentationData))
    }
    const setTime = () => {
        if (parseInt(profile_by_name?.online) + 900 > moment().unix()) {
            return <Online />
        } else {
            return <Offline />
        }
    }
    useEffect(() => {
        init()
        dispatch(getHonors())
    }, [dispatch])

    // Load Pokémon data after profile is loaded, and use the correct method based on whether viewing own profile or another player's
    useEffect(() => {
        if (profile_by_name?.username) {
            if (profile_by_name?.username === current_name) {
                // Load own Pokémon
                dispatch(getPlayerPokemons())
            } else {
                // Load other player's Pokémon
                dispatch(getPokemonsByPlayer(profile_by_name.username))
                    .then(response => {
                        if (response && response.payload && response.payload.data) {
                            setUserPokemon(response.payload.data)
                        }
                    })
            }
        }
    }, [profile_by_name?.username, current_name, dispatch])

    // Load user badges separately once profile data is available
    useEffect(() => {
        if (profile_by_name?.acc_id) {
            dispatch(getUserBadge(profile_by_name.acc_id))
        }
    }, [profile_by_name?.acc_id, dispatch])
    return (
        <div>
            <GoldSiverHeader title='Profile' previous='/home'>
                <Modal show={modal} onHide={handleCloseModal} size='xl' contentClassName='pokemon-modal'>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: 'white' }}>Changes Region</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={6}>

                                <div className="ar_myProfile_select_area mt-3">
                                    <select className="form-select" aria-label="Default select example"
                                        name="wereld"
                                        value={region}
                                        onChange={(e) => { setRegion(e.target.value) }}
                                    >
                                        <option selected>Region</option>
                                        <option value="Kanto">Kanto</option>
                                        <option value="Johto">Johto</option>
                                        <option value="Hoenn">Hoenn</option>
                                        <option value="Sinnoh">Sinnoh</option>
                                        <option value="Unova">Unova</option>
                                        <option value="Kalos">Kalos</option>
                                        <option value="Alola">Alola</option>
                                    </select>
                                </div>
                            </Col>
                        </Row>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handlesubmit} size='lg'>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
                <section className="ar_playerProfile_area_section m-0">
                    <div className="container">
                        <Row>

                            <Col md={12} className='p-2'>
                                <div className="ar_myProfile_single_item2">
                                    <div className="ar_myProfile_sinle_title">
                                        <p className='settings-anchor d-flex justify-content-between'> 
                                            <span>
                                                <img src="/images/myAccount/shap.png" alt="" />
                                                {name === current_name ? `Profile - ${profile_by_name?.username}` : 'Profile'}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="ar_pokeprofile_table_area">
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p className='p-0'> <img src={`/images/characters/${profile_by_name?.character}/npc.png`} height={160} alt="" /></p>
                                            <div>
                                                <div className="ar_pokeProfile_single_wrapper">
                                                    <p><img src="/images/pokeProfile/circle.png" alt="" />ID: <span>{profile_by_name?.user_id}</span></p>
                                                </div>
                                                <div className="ar_pokeProfile_single_wrapper">
                                                    <p><img src="/images/pokeProfile/circle.png" alt="" />Email: <span>{profile_by_name?.email}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">

                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Silver:<span><Silver />{profile_by_name?.silver}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Region: <span>{profile_by_name?.wereld}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Gold: <span><Gold />{profile_by_name?.gold}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Registration IP: <span>{profile_by_name?.ip_aangemeld}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Login IP: <span>{profile_by_name?.ip_ingelogd}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Registered on: <span>{profile_by_name?.aanmeld_datum ? moment(profile_by_name?.aanmeld_datum).format('DD/MM/YYYY') : '-'}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Rank: <span>{profile_by_name?.rank} {profile_by_name?.admin != 0 ? 'Admin' : '-'}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Overall Rating: <span> {profile_by_name?.admin != 0 ? 'Administrator' : '-'}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Age: <span>{profile_by_name?.antiguidade}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Badges: <span> {profile_by_name?.badgeszien}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Pokémon: <span>{profile_by_name?.aantalpokemon}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Pokémon Level 100: <span> {profile_by_name?.aantalpokemon}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />TOP 3 Pokémon: <span>
                                                <span>
                                                    <span><img src="/images/icons/medal3.png" alt="" style={{ margin: '0px' }} />0</span>|
                                                    <span><img src="/images/icons/medal2.png" alt="" style={{ margin: '0px' }} />0</span>|
                                                    <span><img src="/images/icons/medal1.png" alt="" style={{ margin: '0px' }} />0</span>|
                                                </span>
                                            </span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Wins: <span> {profile_by_name?.gewonnen}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Losses: <span>{profile_by_name?.verloren}</span></p>
                                        </div>
                                        <div className="ar_pokeProfile_single_wrapper">
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Status: <span>{setTime()}</span></p>
                                            <p><img src="/images/pokeProfile/circle.png" alt="" />Last Visit: <span>{profile_by_name?.ultimo_login} {profile_by_name?.ultimo_login_hour}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={12}>

                                <div className="ar_playerProfile_area">
                                    <div className="ar_playerProfile_area_item arPlayer_left">
                                        <div className="arPlayerProfile_left_area">
                                            <Row className="character-item2-inner" style={{ maxHeight: '500px' }}>
                                                {
                                                    // Show the current player's Pokémon when viewing own profile
                                                    name === current_name && player_pokemons && player_pokemons.map((item) => {
                                                        return <Col md={6} xs={4} className="character-item2-inner2 gap-2 cursor-pointer" key={`pokemon-${item.id || item.wild_id}`}>
                                                            <div className="inner-cut-bg-profile">
                                                                <div className={`character-item2-inner3 pokemon-gifs ${item.type1 ? item.type1.toLowerCase() : ''} ${item.type2 ? item.type2.toLowerCase() : ''}`}
                                                                    onMouseEnter={() => handleMouseEnter(item.wild_id)}
                                                                    onMouseLeave={handleMouseLeave}>
                                                                    <img src={`images/pokemon/${item.wild_id}.gif`} alt="" />
                                                                    <div className="character-item2-inner4">
                                                                    </div>
                                                                    <div className="character-item2-inner5 b--35" >
                                                                        <p style={{ minHeight: "60px", fontSize: '12px' }}>{item.naam} - Lv <span>{item.level}</span></p>
                                                                    </div>
                                                                    <div className='position-absolute mt-2'
                                                                        id={`pokemon-popup-${item.wild_id}`}
                                                                        style={{ zIndex: 100 }}
                                                                    >
                                                                        {hoveredId === item.wild_id &&
                                                                            <PokemonProfile data={item} />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    })
                                                }
                                                {
                                                    // Show other player's Pokémon when viewing their profile
                                                    name !== current_name && userPokemon && userPokemon.map((item) => {
                                                        return <Col md={6} xs={4} className="character-item2-inner2 gap-2 cursor-pointer" key={`pokemon-${item.id || item.wild_id}`}>
                                                            <div className={`character-item2-inner3 pokemon-gifs ${item.type1 ? item.type1.toLowerCase() : ''} ${item.type2 ? item.type2.toLowerCase() : ''}`}
                                                                onMouseEnter={() => handleMouseEnter(item.wild_id)}
                                                                onMouseLeave={handleMouseLeave}>
                                                                <img src={`images/pokemon/${item.wild_id}.gif`} alt="" />
                                                                <div className="character-item2-inner4">
                                                                    <img src="/images/character-17.png" alt="" />
                                                                </div>
                                                                <div className="character-item2-inner5 b--35" >
                                                                    <p style={{ minHeight: "60px", fontSize: '12px' }}>{item.naam} - Lv <span>{item.level}</span></p>
                                                                </div>
                                                                <div className='position-absolute mt-2'
                                                                    id={`pokemon-popup-${item.wild_id}`}
                                                                    style={{ zIndex: 100 }}
                                                                >
                                                                    {hoveredId === item.wild_id &&
                                                                        <PokemonProfile data={item} />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    })
                                                }
                                                {
                                                    // Empty slots for own profile
                                                    name === current_name && Array.from({ length: (6 - player_pokemons?.length) }).map((_, index) => {
                                                        return <Col md={6} xs={4} className="arPlayerProfle_chacter_item" key={`empty-pokemon-${index}`}>
                                                            <a href="#"><img src="/images/playerProfile/pokemon-home-add.png" alt="" /></a>
                                                        </Col>
                                                    })
                                                }
                                                {
                                                    // Empty slots for other player's profile
                                                    name !== current_name && Array.from({ length: (6 - userPokemon?.length) }).map((_, index) => {
                                                        return <Col md={6} xs={4} className="arPlayerProfle_chacter_item" key={`empty-pokemon-other-${index}`}>
                                                            <div className="empty-pokemon-slot"></div>
                                                        </Col>
                                                    })
                                                }
                                            </Row>

                                        </div>
                                    </div>
                                    <div className="ar_playerProfile_area_item arPlayer_middle">
                                        <div className="ar_playProfile_middle_area">
                                            <div className="ar_playerProfile_middle_top">
                                                <div className="ar_play_middle_top_tag cursor-pointer">
                                                    <a onClick={() => { navigate('/friend-requests') }}><img src="/images/playerProfile/user.png" alt="" /></a>
                                                </div>
                                                <div className="ar_play_middle_top_tag cursor-pointer">
                                                    <a onClick={() => { navigate('/block-list') }}><img src="/images/playerProfile/nished.png" alt="" /></a>
                                                </div>
                                                <div className="ar_play_middle_top_tag" onClick={() => { setModal(true) }}>
                                                    <a href="#"><img src="/images/playerProfile/btnUser.png" alt="" /></a>
                                                    <div className="ar_play_middle_top_tagText">
                                                        <p>ןיטינומ</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="ar_playerMiddle_bottom_area">
                                                <div className="ar_playerMiddle_bottom_single_item">
                                                    <a href="#"><img src="/images/playerProfile/playBtnCha.png" alt="" /></a>
                                                    <div className="ar_playerMiddle_bottom_single_itemTexy">
                                                        <p>
                                                            {/* <span>[off]</span> */}
                                                            {profile_by_name?.username}</p>
                                                        <p>Lv <span>{profile_by_name?.rank}</span></p>
                                                    </div>
                                                </div>
                                                {name === current_name ? (
                                                    <div className="ar_playerMiddle_bottom_single_item" onClick={() => { navigate('/social/challenge-trainer') }}>
                                                        <a href=""><img src="/images/playerProfile/playBtn.png" alt="" /></a>
                                                        <div className="ar_playerMiddle_bottom_single_itemTexy last">
                                                            <p>Challenge</p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="ar_playerMiddle_bottom_single_item" onClick={handleStartPvP}>
                                                        <a href=""><img src="/images/playerProfile/playBtn.png" alt="" /></a>
                                                        <div className="ar_playerMiddle_bottom_single_itemTexy last">
                                                            <p>PVP</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ar_playerProfile_area_item ar_player_right">
                                        <div className="ar_right_minus">
                                            <a href="#" onClick={() => { navigate('/home') }}><img src="/images/playerProfile/X.png" alt="" /></a>
                                        </div>
                                        <div className="ar_playerPorfile_right_top">
                                            <div 
                                                className={`ar_playerProfile_top_btn ${activeTab === 'results' ? 'last' : ''}`}
                                                onClick={() => setActiveTab('results')}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src="/images/playerProfile/tab1.png" alt="" />
                                                <div className="arPlyaderProfile_tab_text">
                                                    <p>{t('Results')}</p>
                                                </div>
                                            </div>
                                            <div 
                                                className={`ar_playerProfile_top_btn ${activeTab === 'badges' ? 'last' : ''}`}
                                                onClick={() => setActiveTab('badges')}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src="/images/playerProfile/tab2.png" alt="" />
                                                <div className="arPlyaderProfile_tab_text last">
                                                    <p>{t('Badges')}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ar_playerProfile_tabArea_wrapper">
                                            {activeTab === 'results' && (
                                                <div className="ar_playerProfile_tab_area arPlay_tab_one">
                                                    <div className="ar_pokeprofile_table_area">
                                                        <div className="ar_pokeProfile_single_wrapper">
                                                            <p><img src="/images/pokeProfile/circle.png" alt="" />{t('Wins')}: <span>{profile_by_name?.gewonnen || 0}</span></p>
                                                            <p><img src="/images/pokeProfile/circle.png" alt="" />{t('Losses')}: <span>{profile_by_name?.verloren || 0}</span></p>
                                                        </div>
                                                        <div className="ar_pokeProfile_single_wrapper">
                                                            <p><img src="/images/pokeProfile/circle.png" alt="" />{t('Pokemon')}: <span>{profile_by_name?.aantalpokemon || 0}</span></p>
                                                            <p><img src="/images/pokeProfile/circle.png" alt="" />{t('Rank')}: <span>{profile_by_name?.rank || 0}</span></p>
                                                        </div>
                                                        <div className="ar_pokeProfile_single_wrapper">
                                                            <p><img src="/images/pokeProfile/circle.png" alt="" />{t('Badges')}: <span>{profile_by_name?.badgeszien || 0}</span></p>
                                                            <p><img src="/images/pokeProfile/circle.png" alt="" />{t('Status')}: <span>{setTime()}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {activeTab === 'badges' && (
                                                <div className="ar_playerProfile_tab_area arPlay_tab_one">
                                                    {user_badges && user_badges.length > 0 ? (
                                                        user_badges.map((item, index) => {
                                                            // Filter only acquired badges
                                                            const acquiredBadges = item.badges?.filter(badge => {
                                                                // Check if badge has acquired field, or check title as fallback
                                                                if (badge.acquired !== undefined) {
                                                                    return badge.acquired === true;
                                                                }
                                                                const title = badge.title || '';
                                                                return title.includes('acquired') && !title.includes('not acquired');
                                                            }) || [];
                                                            
                                                            // Only show region if it has acquired badges
                                                            if (acquiredBadges.length === 0) {
                                                                return null;
                                                            }
                                                            
                                                            return <div key={`region-${item.region}-${index}`}>
                                                                <div className="ar_playerTab_title last">
                                                                    <a href="#"><img src="/images/playerProfile/circle.png" alt="" />{item.region}</a>
                                                                </div>
                                                                <Row className="ar_Playyer_tab_item_wrapper overflow-x-hidden">
                                                                    {acquiredBadges.map((inner, index) => {
                                                                        return <Col md={4} key={`badge-${inner.imgSrc}-${index}`}>
                                                                            <div className='position-relative m-3'>
                                                                                <img src="/images/playerProfile/item2.png" alt="" className='m-0'/>
                                                                                <img src={`/images/badges/${inner.imgSrc}`} alt="" className='m-0 badges-img'/>
                                                                            </div>
                                                                        </Col>
                                                                    })}
                                                                </Row>
                                                            </div>
                                                        })
                                                    ) : (
                                                        <div className="text-center p-4">
                                                            <p>{t('No badges acquired yet')}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </Col>
                            <Col md={6} className='p-3'>
                                <div className="ar_myProfile_single_item2">
                                    <div className="ar_myProfile_sinle_title">
                                        <p className='settings-anchor d-flex justify-content-between'> <span ><img src="/images/myAccount/shap.png" alt="" />Presentation</span><span>
                                            {name === current_name && <FaEdit className='cursor-pointer' size={25} onClick={() => { setDisableFlag(false) }} />}
                                        </span></p>
                                    </div>
                                    <Form.Control as="textarea" disabled={name !== current_name || disableFlag} rows={12} value={presentationData} placeholder="Message" onChange={(e) => setPresentation(e.target.value)} />
                                    {name === current_name && (
                                        <div className="ar_myProfile_btn" >
                                            <span href="#" className='settings-anchor'><img src="/images/myAccount/accBtn.png" alt="" onClick={handlePresentation} /></span>
                                            <div className="ar_myProfile_btn_text">
                                                <p style={{ top: '21px' }}>Save Changes </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col md={6} className='p-3'>
                                <div className="ar_myProfile_single_item2">
                                    <div className="ar_myProfile_sinle_title">
                                        <p className='settings-anchor d-flex justify-content-between'> <span ><img src="/images/myAccount/shap.png" alt="" />Honors</span></p>
                                    </div>
                                    <h4>{profile_by_name?.username} has {honors?.honors_counts} honors, including:</h4>
                                    {honors.honors_Name?.length > 0 && <div className="ar_pokeprofile_table_area">
                                        {honors.honors_Name.map((item, index) => {
                                            return <div className="ar_pokeProfile_single_wrapper" key={`honor-${index}`}>
                                                <p><img src="/images/pokeProfile/circle.png" alt="" />{item.username}</p>
                                                <p><img src="/images/pokeProfile/circle.png" alt="" />{item.date}</p>
                                            </div>
                                        })}
                                    </div>}
                                </div>
                            </Col>

                        </Row>

                    </div>
                </section>

            </GoldSiverHeader>

        </div>
    )
}

export default Profile
